import React, { useState } from 'react';
import logo from './logo_cropped_properly.png';
import { Button } from '@mui/material';
import Survey from './Survey';
import MovieStyles from './MovieContainer.module.css';


const MovieContainer = () => {

    const [survey,setSurvey] = useState(false);
    const [fade,setFade] = useState(false);

    const handleSurvery = () => {
        setSurvey((s) => s = !s );
        setTimeout(() => {
            setFade(true);
        },500);
    }

    const startOver = () => {
        setSurvey(false);
        setFade(false);
    }
    
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        opacity: 0.80,
        width: "90%",
        maxWidth: "800px",
        
        margin: "2rem auto",
        padding: "1rem",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        textAlign: "center"
      }}
    >
        
      <div style={{display:"flex",flexWrap:"wrap",justifyContent:"center",alignItems:"center",borderBottom:"1px solid #ccc",marginBottom:"30px"}}>
      <img
      onClick={() => startOver()}
        alt="BingeMyAI logo"
        src={logo}
        style={{ width: "220px", height: "auto", marginRight:"40px"}}
      />
      <h1 className={MovieStyles.mainh1} style={{lineHeight:"28px"}}>Let AI Choose Your<br/>Next Movie or Show</h1>
      </div>
      <div className={`${MovieStyles.intro} ${survey ? MovieStyles.fadeOut : ''} ${fade ? MovieStyles.hideContainer : ''}`} >
      Just take a quick survey to determine your mood, favorite genre, favorite actor, language and watch 
      time. Then, whether you'd like to start a tv series or a movie. The AI bot will then return a list of 
      results of shows to preview on Netflix or save to watchlist.
      <p></p>
      <Button onClick={() => handleSurvery()} variant='contained'>Click here to begin!</Button>
      </div>
      <div className='startsurvey'>
        {survey && <Survey/>}
      </div>
    </div>
  );
};

export default MovieContainer;
